import { Data$, RemoteData } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { ModuleDocumentOutput } from 'module/model/module-document.output';
import { ModuleOutput } from 'module/model/module.output';
import { IModuleGraph } from 'module/page/graph/module-graph';
import { ObserveModulesByIdsQuery } from 'module/query/observe-modules-by-ids.query';
import { IModule, Module } from 'src/app/domain/module/module';

import { CreateModuleCmd } from '../command/create-module.cmd';
import { ModuleType } from '../model/module.type';
import { ObserveModulesQuery } from '../query/observe-modules.query';

export abstract class ModuleApplicationPort {
	public abstract observeAttachedModulesByIds(
		ids: string[]
	): Observable<Module[]>;

	public abstract fetchFirstCoachingPlanModule(): Observable<string | Error>;

	public abstract fetchOnBoardingModuleId(
		organizationId: string
	): Observable<string>;

	public abstract observeModuleById(id: string): Observable<RemoteData<IModule>>;

	public abstract observeModules(
		query: ObserveModulesQuery
	): Observable<RemoteData<IModule[]>>;

	public abstract generateModuleDocumentUrl(
		file: File
	): Observable<ModuleDocumentOutput>;

	public abstract createModule(cmd: CreateModuleCmd): Promise<ModuleOutput>;

	public abstract observeUserModulesByIds(
		query: ObserveModulesByIdsQuery
	): Observable<RemoteData<IModule[]>>;

	public abstract observeModuleByType(
		type: ModuleType
	): Observable<RemoteData<IModule>>;

	public abstract observeModuleGraphsByIds(ids: string[]): Data$<IModuleGraph[]>;

	public abstract saveModules(ids: string[]): Promise<void>;
}
